export default __webpack_public_path__ + "resources/icons/n140-a4e5.png";